export const CIP8_TITLE = "CIP8_TITLE";